import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './AdminPage.module.css'
import {
  ConfigProvider,
  Input,
  Menu,
  message,
  Modal,
  Tag,
  Tooltip,
  Upload,
} from 'antd'

import menu_appBillManager from './menu_appBillManager.svg'
import menu_appBillManager_selected from './menu_appBillManager_selected.svg'
import menu_schoolInfo from './menu_schoolInfo.svg'
import menu_schoolInfo_selected from './menu_schoolInfo_selected.svg'
import menu_userInfo from './menu_userInfo.svg'
import menu_userInfo_selected from './menu_userInfo_selected.svg'
import menu_jifeiXiaohao from './menu_jifeiXiaohaoManager.svg'
import menu_jifeiXiaohao_selected from './menu_jifeiXiaohaoManager_selected.svg'
import menu_famousTeacher from './menu_famousTeacher.svg'
import menu_famousTeacher_selected from './menu_famousTeacher_selected.svg'
import menu_reviewAppManager from './menu_reviewAppManager.svg'
import menu_reviewAppManager_selected from './menu_reviewAppManager_selected.svg'
import menu_points_recharge_ratio from './menu_points_recharge_ratio.svg'
import menu_points_recharge_ratio_selected from './menu_points_recharge_ratio_selected.svg'
import menu_points_recharge_order_list from './menu_points_recharge_order_list.svg'
import menu_points_recharge_order_list_selected from './menu_points_recharge_order_list_selected.svg'

import { selectCurrentMenuKey, setCurrentMenuKey } from './AdminPageSlice.js'
import {
  changeHeaderImgRequest,
  changeNameRequest,
  getAliOssTokenRequest,
} from './AdminPageApi.js'
import { getSixMathRandom } from '../../util/handMath.js'
import OSS from 'ali-oss'
import { ALI_OSS_PATH } from '../../util/constants.js'
import UserInfo from './userManager/UserManager'
import SchoolInfoManager from './SchoolInfoManager/SchoolInfoManager'
import SchoolRechargePoints from './SchoolRechargePoints/SchoolRechargePoints'
import AppBillingManage from './AppBillingManage/AppBillingManage'
import UserRechargePoints from './UserRechargePoints/UserRechargePoints'
import JifeiXiaohaoManager from './JifeiXiaohaoManager/JifeiXiaohaoManager'
import FamousTeacherManager from './FamousTeacherManager/FamousTeacherManager'
import ReviewAppManager from './ReviewAppManager/ReviewAppManager.js'
import PointsRechargeRatioManage from './PointsRechargeRatioManage/PointsRechargeRatioManage.js'
import PointsRechargeOrderList from './PointsRechargeOrderList/PointsRechargeOrderList.js'
import ResourceManager from './ResourceManager/ResourceManager'
import Cookies from 'js-cookie'

let client
let clientExpTime

export default function AdminPage() {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const current = useSelector(selectCurrentMenuKey)
  const [arrow, setArrow] = useState('Show')
  const [openChangeNameModal, setOpenChangeNameModal] = useState(false)
  const [name, setName] = useState('')
  const [userHeaderImg, setUserHeaderImg] = useState(
    Cookies.get('image_url')
  )
  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false
    }
    if (arrow === 'Show') {
      return true
    }
    return {
      pointAtCenter: true,
    }
  }, [arrow])

  const items = [
    {
      key: '1',
      // icon: <PieChartOutlined />,
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 1
              ? menu_schoolInfo_selected
              : menu_schoolInfo
          }
          width={25}
          height={25}
        />
      ),
      label: '学校信息管理',
    },
    {
      key: '2',
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 2
              ? menu_userInfo_selected
              : menu_userInfo
          }
          width={25}
          height={25}
        />
      ),
      label: '用户信息管理',
    },
    // {
    //   key: '3',
    //   icon: (
    //     <img
    //       src={
    //         String(current > 10 ? Math.floor(current / 10) : current) == 3
    //           ? menu_appBillManager_selected
    //           : menu_appBillManager
    //       }
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: '应用集成管理',
    // },
    // {
    //   key: '6',
    //   icon: (
    //     <img
    //       src={
    //         String(current > 10 ? Math.floor(current / 10) : current) == 6
    //           ? menu_reviewAppManager_selected
    //           : menu_reviewAppManager
    //       }
    //       width={25}
    //       height={25}
    //     />
    //   ),
    //   label: '评测应用管理',
    // },
    {
      key: '4',
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 4
              ? menu_jifeiXiaohao_selected
              : menu_jifeiXiaohao
          }
          width={25}
          height={25}
        />
      ),
      label: '计费消耗管理',
    },
    // {
    //     key: '5',
    //     icon: <img src={String(current>10?Math.floor(current/10):current) == 5 ? menu_famousTeacher_selected : menu_famousTeacher} width={25} height={25}/>,
    //     label: '名师信息管理'
    // },
    {
      key: '7',
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 7
              ? menu_points_recharge_ratio_selected
              : menu_points_recharge_ratio
          }
          width={25}
          height={25}
        />
      ),
      label: '积分充值管理',
    },
    {
      key: '8',
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 8
              ? menu_points_recharge_order_list_selected
              : menu_points_recharge_order_list
          }
          width={25}
          height={25}
        />
      ),
      label: '线上订单管理',
    },
    {
      key: '9',
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 9
              ? menu_points_recharge_order_list_selected
              : menu_points_recharge_order_list
          }
          width={25}
          height={25}
        />
      ),
      label: '资源管理',
    },
    {
      key: '10',
      icon: (
        <img
          src={
            String(current > 10 ? Math.floor(current / 10) : current) == 10
              ? menu_appBillManager_selected
              : menu_appBillManager
          }
          width={25}
          height={25}
        />
      ),
      label: '应用管理',
    },
  ]

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getAliOssToken()

    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const changeMenuMethod = (e) => {
    dispatch(setCurrentMenuKey(e.key))
  }

  const handleOk = (e) => {
    console.log(name)
    changeNameRequest(name, (data) => {
      console.log(data)
      if (data.ret == 1) {
        Cookies.set('name', name)
        setName('')
        setOpenChangeNameModal(false)
      } else {
        messageApi.info(data.msg)
      }
    })
  }

  const handleCancel = () => {
    setName('')
    setOpenChangeNameModal(false)
  }

  function getAliOssToken() {
    let nowDate = new Date().getTime()
    if (!client || nowDate - clientExpTime > 1200000) {
      clientExpTime = new Date().getTime()
      getAliOssTokenRequest((data) => {
        if ('Credentials' in data) {
          client = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: 'oss-cn-qingdao',
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: data.Credentials.AccessKeyId,
            accessKeySecret: data.Credentials.AccessKeySecret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: data.Credentials.SecurityToken,
            refreshSTSToken: async () => {
              // 向您搭建的STS服务获取临时访问凭证。
              getAliOssTokenRequest((data) => {
                return {
                  accessKeyId: data.Credentials.AccessKeyId,
                  accessKeySecret: data.Credentials.AccessKeySecret,
                  stsToken: data.Credentials.SecurityToken,
                }
              })
            },
            // 刷新临时访问凭证的时间间隔，单位为毫秒。
            refreshSTSTokenInterval: 3000000,
            // 填写Bucket名称。
            bucket: 'tgnp',
          })
        }
      })
    }
  }

  const customRequest = async (options) => {
    const { onSuccess, onError, file } = options

    try {
      // 使用阿里云OSS SDK上传文件
      let timestamp = new Date().getTime()
      let random = getSixMathRandom()
      const result = await client.put(
        ALI_OSS_PATH + 'user/' + timestamp + random + file.name,
        file,
      )
      file.url = result.url.replace('http:', 'https:')
      onSuccess(file)
      changeImgMethod(file.url)
    } catch (e) {
      message.error(`头像上传失败`)
      onError(e)
    }
  }

  function changeImgMethod(url) {
    changeHeaderImgRequest(url, (data) => {
      console.log(data)
      if (data.ret == 1) {
        Cookies.set('image_url', url)
        setUserHeaderImg(url)
      } else {
        messageApi.info(data.msg)
      }
    })
  }

  function handleChange1(info) {
    getAliOssToken()
    let tempList = info.fileList.map((item, index) => {
      let tempDic = {
        url: item.url,
        uid: item.uid,
        status: item.status,
        name: item.name,
      }
      return tempDic
    })
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.leftMenus}>
        <img
          className={styles.menuLogo}
          src={require('../../assert/logo_name_icon.png')}
        ></img>
        <div className={styles.headerContainer}>
          <Upload
            listType="picture"
            fileList={[]}
            onChange={handleChange1}
            customRequest={customRequest}
            accept=".jpg,.png,.jpeg,.svg"
          >
            <img
              className={styles.avatar}
              src={
                userHeaderImg == 'null'
                  ? require('./avatar.png')
                  : userHeaderImg
              }
            ></img>
          </Upload>
          <div className={styles.rightBox}>
            <Tooltip
              placement="bottom"
              title={Cookies.get('name')}
              arrow={mergedArrow}
            >
              <text
                className={styles.teacherName}
                onClick={(e) => {
                  setOpenChangeNameModal(true)
                }}
              >
                {Cookies.get('name')}
              </text>
            </Tooltip>
          </div>
        </div>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#f5b544',
            },
          }}
        >
          <Menu
            defaultSelectedKeys={['1']}
            mode="inline"
            items={items}
            onClick={changeMenuMethod}
            selectedKeys={[
              String(current > 10 ? Math.floor(current / 10) : current),
            ]}
            inlineCollapsed={false}
          />
        </ConfigProvider>
        <Modal
          title="请输入新的名称"
          open={openChangeNameModal}
          onOk={handleOk}
          onCancel={handleCancel}
          width={300}
        >
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="请输入名称..."
          />
        </Modal>
      </div>
      <div className={styles.rightMenus}>
        {current == 1 ? (
          <SchoolInfoManager />
        ) : current == 11 ? (
          <SchoolRechargePoints />
        ) : current == 2 ? (
          <UserInfo />
        ) : current == 21 ? (
          <UserRechargePoints />
        ) : current == 3 ? (
          <AppBillingManage />
        ) : current == 4 ? (
          <JifeiXiaohaoManager />
        ) : current == 5 ? (
          <FamousTeacherManager />
        ) : current == 6 ? (
          <ReviewAppManager />
        ) : (
          <div></div>
        )}
        {current == 7 ? (
          <PointsRechargeRatioManage />
        ) : (
          <div></div>
        )}
        {current == 8 ? (
          <PointsRechargeOrderList />
        ) : (
          <div></div>
        )}
        {current == 9 ? (
          <ResourceManager />
        ) : (
          <div></div>
        )}
        {current == '10' ? (
          <iframe
            src="https://ygbh.gamification.org.cn/rongzhi_yingyongguanli/index.html"
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="应用管理"
          />
        ) : (
          <div></div>
        )}
      </div>
    </div>
  )
}

